<template>

	<div id="dimensioning_view" class="frame">
		<div class="inner">
		 
			<teleport to="#route_title">
				<div class="flex gap-2 items-center">
					<span>-</span><span>Dimensionierung</span>
				</div>
			</teleport>
			
			<div class="form_field_wrap" v-if="state.dim.mode == 'input'">
				 				
				<FormInput type="number" :label="trans('Volumenstrom in m³/h')" v-model="state.dim.input.vstrom_m3h" @update="updateVstrom('m3h')" modifier="ff2" />
				<FormInput type="number" :label="trans('Volumenstrom in l/s')" v-model="state.dim.input.vstrom_ls" @update="updateVstrom('ls')" modifier="ff2" />
				<FormInput type="number" :label="trans('Volumenstrom in l/h')" v-model="state.dim.input.vstrom_lh" @update="updateVstrom('lh')" modifier="ff2" />
				<FormInput type="number" :label="trans('Geschwindigkeit in m/s')" v-model="state.dim.input.speed_ms" modifier="ff2" />
				
				<a class="button my-4" @click.prevent="calcArea()">Querschnitt berechnen</a>
				 
				<FormSelect :label="trans('Art')" v-model="state.dim.input.type" :options="[
					{ key: 'kanal', label: 'Kanal' },
					{ key: 'rohr', label: 'Rohr' }
				]" />
				 
				<template v-if="state.dim.input.type === 'kanal'">
					<FormInput type="number" :label="trans('Höhe in mm')" v-model="state.dim.input.height_mm" modifier="ff2" />
					<FormInput type="number" :label="trans('Breite in mm')" v-model="state.dim.input.width_mm" modifier="ff2" /> 
				</template>
				<template v-if="state.dim.input.type === 'rohr'">
					<FormInput type="number" :label="trans('Durchmesser in mm')" v-model="state.dim.input.diameter" />
				</template>
				
				<div class="w-full flex gap-2 flex-col">
					<a class="button mt-4" ref="calcSpeed" @click.prevent="calcSpeed($event)">Geschwindigkeit berechnen</a>
					<a class="button" ref="calcVStrom" @click.prevent="calcSpeed($event)">Volumenstrom berechnen</a>
					<a class="button" @click.prevent="state.dim.mode = 'hd';">Hydraulischen Durchmesser berechnen</a>
					<a class="button" @click.prevent="state.dim.mode = 'rundeckig'">rund &lt;-> eckig | eckig &lt;-> rund</a>
				</div>
				 
			</div>
			<div class="form_field_wrap" v-else-if="state.dim.mode === 'output'">
				
				<FormInput :disabled="true" type="number" :label="trans('Volumenstrom in m³/h')" v-model="state.dim.input.vstrom_m3h" modifier="ff2" /> 
				<FormInput :disabled="true" type="number" :label="trans('Geschwindigkeit in m/s')" v-model="state.dim.input.speed_ms" modifier="ff2" />
				<FormInput :disabled="true" type="number" :label="trans('Querschnittsfläche in mm²')" v-model="state.dim.output.area_mm2" modifier="ff2" />
				<FormInput :disabled="true" type="number" :label="trans('Querschnittsfläche in m²')" v-model="state.dim.output.area_m2" modifier="ff2" />
				
				<h2>Rohr</h2>
				
				<FormInput :disabled="true" type="number" :label="trans('Empfohlener ∅ in mm')" v-model="state.dim.output.diameter_mm" modifier="ff0" />
				
				<a class="button my-4" @click.prevent="toTube()">In Rohrrechner übernehmen</a>
				
				<h2>Kanal</h2>
				
				<FormInput type="number" :label="trans('Höhe in mm')" v-model="state.dim.output.height_mm" modifier="ff2" @update="calcOutputCanal('height')" /> 
				<FormInput type="number" :label="trans('Breite in mm')" v-model="state.dim.output.width_mm" modifier="ff2" @update="calcOutputCanal('width')" /> 
				
				<a class="button my-4" @click.prevent="toCanal">In Kanalrechner übernehmen</a>
				
				<p class="text-center mt-4">
					Der Hersteller übernimmt keine Gewähr für das Programm. Es wird darauf hingewiesen, dass diese Software möglicherweise Fehler enthält. Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.
				</p>
				 
				<div class="flex w-full gap-4 mt-4">
					<a class="button" @click.prevent="state.dim.mode = 'input'">Neu eingeben</a>
					<a class="button" @click.prevent="sendMailTunnel('dimensioning_view')">Verschicken</a>
				</div>
				
			</div>
			<div class="form_field_wrap form_field_wrap_50_50" v-else-if="state.dim.mode === 'hd'">
				<div class="form_field form_field_select">
					<div class="w-full value">
						<select class="w-full" v-model="state.dim.hd.type" @change="changeHdType">
							<option v-for="(item ,i) of arHd" v-html="item.label" :value="i"></option>
						</select>
					</div>
				</div>
				<img class="w-full" :src="hd.img" />
				
				<FormInput :disabled="true" :label="trans('Berechnungsformel')" v-model="hd.formula" />
				
				<div class="form_field_wrap mt-4">
					<template v-if="state.dim.hd.type === 'rund'">
						<FormInput :label="trans('Durchmesser d [mm]')" v-model="state.dim.hd.diameter" @update="calcHd()" modifier="ff2" />
					</template>
					<template v-else-if="state.dim.hd.type === 'quadratisch'">
						<FormInput :label="trans('Seitenlänge a [mm]')" v-model="state.dim.hd.a" @update="calcHd()" modifier="ff2" />
					</template>
					<template v-else-if="state.dim.hd.type === 'rechteckig'">
						<FormInput :label="trans('Seitenlänge a [mm]')" v-model="state.dim.hd.a" @update="calcHd()" modifier="ff2" />
						<FormInput :label="trans('Seitenlänge b [mm]')" v-model="state.dim.hd.b" @update="calcHd()" modifier="ff2" />
					</template>
					<template v-else-if="state.dim.hd.type === 'ellipse'">
						<FormInput :label="trans('Gr. Radius a [mm]')" v-model="state.dim.hd.a" @update="calcHd()" modifier="ff2" />
						<FormInput :label="trans('Kl. Radius b [mm]')" v-model="state.dim.hd.b" @update="calcHd()" modifier="ff2" />
					</template>
					<template v-else-if="state.dim.hd.type === 'oval'">
						<FormInput :label="trans('Mass a [mm]')" v-model="state.dim.hd.a" @update="calcHd()" modifier="ff2" />
						<FormInput :label="trans('Mass b [mm]')" v-model="state.dim.hd.b" @update="calcHd()" modifier="ff2" />
					</template>
					<template v-else-if="state.dim.hd.type === 'dreieck'">
						<FormInput :label="trans('Höhe h [mm]')" v-model="state.dim.hd.h" @update="calcHd()" modifier="ff2" />
					</template>
					<template v-else-if="state.dim.hd.type === 'beliebig'">
						<FormInput :label="trans('Querschnitt A [m²]')" v-model="state.dim.hd.a" @update="calcHd()" modifier="ff2" />
						<FormInput :label="trans('Umfang U [m]')" v-model="state.dim.hd.b" @update="calcHd()" modifier="ff2" />
					</template>
					<template v-else-if="state.dim.hd.type === 'kreisring'">
						<FormInput :label="trans('Gr. Durchmesser D [mm]')" v-model="state.dim.hd.a" @update="calcHd()" modifier="ff2" />
						<FormInput :label="trans('Gr. Durchmesser d [mm]')" v-model="state.dim.hd.b" @update="calcHd()" modifier="ff2" />
					</template>
				</div>
			
				<FormInput :disabled="true" :label="trans('Querschnittsfläche in m²')" v-model="state.dim.hd.area_m2" modifier="ff2" />
				<FormInput :disabled="true" :label="trans('Hydraulischer Durchmesser in mm')" v-model="state.dim.hd.hyd_mm" modifier="ff2" />
				<FormInput :disabled="true" :label="trans('Empfohlener Durchmesser in mm')" v-model="state.dim.hd.hyd_propose_mm" modifier="ff2" />
				
				<p class="text-center mt-4">
					Der Hersteller übernimmt keine Gewähr für das Programm. Es wird darauf hingewiesen, dass diese Software möglicherweise Fehler enthält. Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.
				</p>
				
				<div class="flex w-full gap-4 mt-4">
					<a class="button" @click.prevent="state.dim.mode = 'input'">Zurück</a>
					<a class="button" @click.prevent="sendMailTunnel('dimensioning_view_hd')">Verschicken</a>
				</div> 
				
			</div>
			<div class="form_field_wrap" v-else-if="state.dim.mode === 'rundeckig'">
				
				<FormInput type="number" modifier="ff2" :label="trans('Nennweite in mm')" v-model="state.dim.rundeckig.re.input.normalwidth_mm" @input="rundeckig_calc('normalwidth_mm', $event)" />
				<FormInput type="number" modifier="ff2" :label="trans('Höhe Kanal in mm')" v-model="state.dim.rundeckig.re.input.height_mm" @input="rundeckig_calc('height_mm', $event)" />
				<FormInput type="number" modifier="ff2" :label="trans('Breite Kanal in mm')" v-model="state.dim.rundeckig.re.input.width_mm" @input="rundeckig_calc('width_mm', $event)" />
				
				<a class="button" @click.prevent="calcRE()">Rund -> Eckig</a>
				<FormInput type="number" :disabled="true" :label="trans('Querschnittsfläche (A) in m²')" v-model="state.dim.rundeckig.re.output.area_m2" modifier="ff5" />
				<FormInput type="number" :disabled="true" :label="trans('Höhe Kanal in mm')" v-model="state.dim.rundeckig.re.output.height_mm" modifier="ff2" />
				<FormInput type="number" :disabled="true" :label="trans('Breite Kanal in mm')" v-model="state.dim.rundeckig.re.output.width_mm" modifier="ff2" />
				
				<hr class="my-4" />
				
				<FormInput type="number" :label="trans('Höhe Kanal in mm')" v-model="state.dim.rundeckig.er.input.height_mm" modifier="ff2" />
				<FormInput type="number" :label="trans('Breite Kanal in mm')" v-model="state.dim.rundeckig.er.input.width_mm" modifier="ff2" />
				<a class="button" @click.prevent="calcER()">Eckig -> Rund</a>
				<FormInput type="number" :disabled="true" :label="trans('Querschnittsfläche (A) in m²')" v-model="state.dim.rundeckig.er.output.area_m2" modifier="ff4" />
				<FormInput type="number" :disabled="true" :label="trans('Nennweite in mm')" v-model="state.dim.rundeckig.er.output.normalwidth_mm" modifier="ff2" />
				<FormInput type="number" :disabled="true" :label="trans('Empfohlener Durchmesser in mm')" v-model="state.dim.rundeckig.er.output.diameter_mm" modifier="ff2" />
				
				<p class="text-center mt-4">
					Der Hersteller übernimmt keine Gewähr für das Programm. Es wird darauf hingewiesen, dass diese Software möglicherweise Fehler enthält. Die Nutzung dieser Software erfolgt auf eigene Gefahr des Anwenders.
				</p>
				
				<div class="mt-4 w-full flex">
					<a class="button" @click.prevent="state.dim.mode = 'input'">Zurück</a>
					<div class="grow w-full"></div>
				</div>
				
			</div>
			
		</div>
	</div>

</template>

<script>

	import FormInput from "@/components/FormInput";
	import FormSelect from "@/components/FormSelect"; 
 
	export default {
		name: "DimensioningView",
		inject: [
			'trans', 'alert', 'sendMail', 'ff2', 'tf'
		],
		components: {
			FormInput, FormSelect
		},
		methods: {
			calc_hd_empf(dh) {
        
				let dd = 0.0;
                let empfdurchmesser = [80, 100, 125, 140, 150, 160, 180, 200, 224, 250, 280, 300, 315, 355, 400, 450, 500, 560, 600, 630, 710, 800, 900, 1000, 1120, 1250, 1400, 1500, 1600];
        
				if (dh > 1600) { return dh; }

                for (let i = 0; i < empfdurchmesser.length; i++) {
					
                    if (dh <= empfdurchmesser[i]) {
						
                        dd = empfdurchmesser[i];
                
						break;
            
					}
        
				}
        
				return dd;
    
			},
			updateVstrom(el) {
				
				if (el === 'm3h') {
					
					this.state.dim.input.vstrom_ls = parseFloat((this.state.dim.input.vstrom_m3h * 1000 / 60 / 60).toFixed(2));
					this.state.dim.input.vstrom_lh = parseFloat((this.state.dim.input.vstrom_m3h * 1000).toFixed(2));
					 
				} else if (el === 'ls') {
					
					this.state.dim.input.vstrom_lh = parseFloat((this.state.dim.input.vstrom_ls * 60 * 60).toFixed(2));
					this.state.dim.input.vstrom_m3h = parseFloat((this.state.dim.input.vstrom_ls / 1000 * 60 * 60).toFixed(2)); 
					
				} else if (el === 'lh') {
					
					this.state.dim.input.vstrom_ls = parseFloat((this.state.dim.input.vstrom_lh / 60 / 60).toFixed(2));
					this.state.dim.input.vstrom_m3h = parseFloat((this.state.dim.input.vstrom_lh / 1000).toFixed(2));
					
				}
				
			},
			calcOutputCanal(change) {
				
				if (change === 'height') {
					
					this.state.dim.output.width_mm = this.state.dim.output.area_mm2 / this.state.dim.output.height_mm;
					 
				} else if (change === 'width') {
					
					this.state.dim.output.height_mm = this.state.dim.output.area_mm2 / this.state.dim.output.width_mm;
					
				}
				
			},
			calcArea() {
				 				
				if (this.state.dim.input.speed_ms <= 0 || !this.state.dim.input.speed_ms) { this.alert('Bitte eine gültige Geschwindigkeit angeben!', 'Fehler'); return; }
				if (this.state.dim.input.vstrom_m3h <= 0 || !this.state.dim.input.vstrom_m3h) { this.alert('Bitte einen gültigen Volumenstrom angeben!', 'Fehler'); return; }
				
				this.state.dim.output.area_m2 = this.state.dim.input.vstrom_m3h / (this.state.dim.input.speed_ms * 60 * 60);
                this.state.dim.output.area_mm2 = this.state.dim.output.area_m2 * 1000 * 1000;
 	 
				let diameter_calc = Math.sqrt((4 * this.state.dim.output.area_mm2) / Math.PI);
                let arDiameter = [1600, 1500, 1400, 1250, 1120, 1000, 900, 800, 710, 630, 560, 500, 450, 400, 355, 315, 300, 250, 200, 180, 160, 150, 125, 100, 80];

                this.state.dim.output.diameter_mm = 1600;

                for (let d of arDiameter) {

                    if (d > diameter_calc) {

						this.state.dim.output.diameter_mm = d;
					
					} else {

                        break;

                    }

                }
				
				this.state.dim.mode = 'output';
				
			},
			calcSpeed(event) {
			 
				let a_m2 = 0;
				
				if (this.state.dim.input.type === 'kanal') {
					
					if (!this.state.dim.input.width_mm || !this.state.dim.input.height_mm ||
						this.state.dim.input.width_mm <= 0 || this.state.dim.input.height_mm <= 0) {
 
						this.alert('Bitte Eingaben bei der Kanallänge und -breite überprüfen.');
						return;
						
                    }
					
					a_m2 = (this.state.dim.input.width_mm / 1000) * (this.state.dim.input.height_mm / 1000);
					
				} else if (this.state.dim.input.type === 'rohr') {
				
					if (!this.state.dim.input.diameter || this.state.dim.input.diameter <= 0) {
						
						this.alert('Bitte die Eingaben bei dem Rohrdurchmesser überprüfen.');
                        return;

                    }
					
					a_m2 = Math.PI * Math.pow(((this.state.dim.input.diameter / 1000) / 2), 2);
					
				}
				
				if (event.target === this.$refs.calcSpeed) {
					
					if (!this.state.dim.input.vstrom_lh || this.state.dim.input.vstrom_lh <= 0) {

						this.alert('Bitte einen gültigen Volumenstrom eingeben.');
                        return;
					
					}
                    
					// Geschwindigkeit berechnen
                    this.state.dim.input.speed_ms = this.state.dim.input.vstrom_m3h / (a_m2 * 3600);
					 
				} else if (event.target === this.$refs.calcVStrom) {
			 
					if (!this.state.dim.input.speed_ms || this.state.dim.input.speed_ms <= 0) {

						this.alert('Bitte die Eingabe bei der Geschwindigkeit überprüfen.');
	                    return;
	
	                }
					
					this.state.dim.input.vstrom_m3h = a_m2 * this.state.dim.input.speed_ms * 3600;
					
					
				}
				
			},
			changeHdType() {
				 
				this.state.dim.hd.diameter = null;
				this.state.dim.hd.area_m2 = null;
				this.state.dim.hd.hyd_mm = null;
				this.state.dim.hd.hyd_propose_mm = null;
				this.state.dim.hd.a = null;
				this.state.dim.hd.b = null; 
				this.state.dim.hd.h = null; 
				
			},
			calcHd() {
			
				if (this.state.dim.hd.type === 'rund') {
				
					this.state.dim.hd.area_m2 = (Math.PI * this.state.dim.hd.diameter * this.state.dim.hd.diameter / 4) / 1000000;
					this.state.dim.hd.hyd_mm = this.state.dim.hd.diameter;
					this.state.dim.hd.hyd_propose_mm = this.calc_hd_empf(this.state.dim.hd.hyd_mm);

				} else if (this.state.dim.hd.type === 'quadratisch') {
					
					this.state.dim.hd.area_m2 = this.state.dim.hd.a * this.state.dim.hd.a / 1000000;
					this.state.dim.hd.hyd_mm = this.state.dim.hd.a;
					this.state.dim.hd.hyd_propose_mm = this.calc_hd_empf(this.state.dim.hd.hyd_mm);
					
				} else if (this.state.dim.hd.type === 'rechteckig') {
					
					this.state.dim.hd.area_m2 = this.state.dim.hd.a * this.state.dim.hd.b / 1000000;
					this.state.dim.hd.hyd_mm = (2 * this.state.dim.hd.a * this.state.dim.hd.b) / (this.state.dim.hd.a + this.state.dim.hd.b);
					this.state.dim.hd.hyd_propose_mm = this.calc_hd_empf(this.state.dim.hd.hyd_mm);
					
				} else if (this.state.dim.hd.type === 'ellipse') {
					
					this.state.dim.hd.area_m2 = Math.PI * this.state.dim.hd.a * this.state.dim.hd.b / 1000000;
					
					let l = (this.state.dim.hd.a - this.state.dim.hd.b) / (this.state.dim.hd.a + this.state.dim.hd.b);
					let u = (Math.PI * (this.state.dim.hd.a + this.state.dim.hd.b) * (1 + (3 * l * l / (10 + Math.sqrt(4 - 3 * l * l)))));
					
					this.state.dim.hd.hyd_mm = 4 * this.state.dim.hd.area_m2 * 1000000 / u;
					this.state.dim.hd.hyd_propose_mm = this.calc_hd_empf(this.state.dim.hd.hyd_mm);
					 					
				} else if (this.state.dim.hd.type === 'oval') {
					
                    this.state.dim.hd.area_m2 = ((Math.PI * this.state.dim.hd.b * this.state.dim.hd.b / 4) + (this.state.dim.hd.a * this.state.dim.hd.b)) / 1000000;
                    this.state.dim.hd.hyd_mm = (4 * this.state.dim.hd.area_m2 * 1000000) / ((2 * this.state.dim.hd.a) + (Math.PI * this.state.dim.hd.b));
					this.state.dim.hd.hyd_propose_mm = this.calc_hd_empf(this.state.dim.hd.hyd_mm);
            		
				} else if (this.state.dim.hd.type === 'dreieck') {
					
					this.state.dim.hd.area_m2 = ((this.state.dim.hd.h * this.state.dim.hd.h) / 2) / 1000000;
					this.state.dim.hd.hyd_mm = (this.state.dim.hd.h * this.state.dim.hd.h * Math.sqrt(3)) / (3 * this.state.dim.hd.h);
					this.state.dim.hd.hyd_propose_mm = this.calc_hd_empf(this.state.dim.hd.hyd_mm);
						
				} else if (this.state.dim.hd.type === 'beliebig') {

					this.state.dim.hd.area_m2 = this.state.dim.hd.a;
					this.state.dim.hd.hyd_mm = 4 * this.state.dim.hd.a / this.state.dim.hd.b;
					this.state.dim.hd.hyd_propose_mm = this.calc_hd_empf(this.state.dim.hd.hyd_mm * 1000);
						
				} else if (this.state.dim.hd.type === 'kreisring') {
					
					this.state.dim.hd.area_m2 = (Math.PI * (this.state.dim.hd.a * this.state.dim.hd.a - this.state.dim.hd.b * this.state.dim.hd.b) / 4) / 1000000;
					this.state.dim.hd.hyd_mm = this.state.dim.hd.a - this.state.dim.hd.b;
                    this.state.dim.hd.hyd_propose_mm = this.calc_hd_empf(this.state.dim.hd.hyd_mm);
					
				}
				
			},
			toCanal() {
				
				this.state.canal.mode = 'input';
				this.state.canal.input.height_mm = this.state.dim.output.height_mm;
				this.state.canal.input.width_mm = this.state.dim.output.width_mm;
				
				this.$router.push('/canal');
				
			},
			toTube() {
			
				this.state.tube.mode = 'input';
				this.state.tube.input.diameter_mm = this.state.dim.output.diameter_mm;
				
				this.$router.push('/tube');
				
			},
			rundeckig_calc(src, event) {
			
				let input_value = this.tf(event.target.value);
				let dA = Math.PI * Math.pow((this.state.dim.rundeckig.re.input.normalwidth_mm / 2), 2);
				
				if (src === 'width_mm' && this.state.dim.rundeckig.re.input.normalwidth_mm > 0) {
					 
					// Breite hat sich geändert -> Höhe ermitteln
					 
					let value = 0;
					
					if (input_value > 0) value = dA / input_value;
					this.state.dim.rundeckig.re.input.height_mm = Math.round(value);
										
				} else if (src === 'height_mm' && this.state.dim.rundeckig.re.input.normalwidth_mm > 0) {
					
		            // Höhe hat sich geändert -> Breite ermitteln
					
					let value = 0;
					
					if (input_value > 0) value = (dA / input_value);
		            this.state.dim.rundeckig.re.input.width_mm = Math.round(value);
			
				} else if (src === 'normalwidth_mm') {
					
					dA = Math.PI * Math.pow((this.tf(event.target.value) / 2), 2);
					
					if (this.state.dim.rundeckig.re.input.height_mm > 0) {
						
						// Höhe definiert -> Breite ermitteln
						
						let input_value = this.state.dim.rundeckig.re.input.height_mm;						
						let value = (dA / input_value);
						
			            this.state.dim.rundeckig.re.input.width_mm = Math.round(value);
					
					} else if (this.state.dim.rundeckig.re.input.width_mm > 0) {
						
						// Breite definiert -> Höhe ermitteln
						
						let input_value = this.state.dim.rundeckig.re.input.width_mm;						
						let value = (dA / input_value);
						
			            this.state.dim.rundeckig.re.input.height_mm = Math.round(value);
						
					}
					
				}
				
			},
			sendMailTunnel(mail_key) {
				
				if (mail_key === 'dimensioning_view') {
					
					this.sendMail({
						'###VOLUMENSTROM_L###': this.ff2(this.state.dim.input.vstrom_ls),
						'###VOLUMENSTROM_M###': this.ff2(this.state.dim.input.vstrom_m3h),
						'###VOLUMENSTROM_H###': this.ff2(this.state.dim.input.vstrom_lh),
						'###GESCHWINDIGKEIT###': this.ff2(this.state.dim.input.speed_ms),
						'###DURCHMESSER_MM###': this.ff2(this.state.dim.input.diameter),
						'###HOEHE_MM###': this.ff2(this.state.dim.input.height_mm),
						'###BREITE_MM###': this.ff2(this.state.dim.input.width_mm)
					}, mail_key);

				} else if (mail_key === 'dimensioning_view_hd') {
					
					let mass1 = this.state.dim.hd.a;
					let mass2 = this.state.dim.hd.b;
					
					if (this.state.dim.hd.type === 'dreieck') {
						
						mass1 = this.state.dim.hd.h;
						mass2 = 'n.A';
						
					} else if (this.state.dim.hd.type === 'quadratisch') {
						
						mass1 = this.state.dim.hd.a;
						mass2 = 'n.A';
						
					} else if (this.state.dim.hd.type === 'rund') {
						
						mass1 = this.state.dim.hd.diameter;
						mass2 = 'n.A';
						
					}
					
					this.sendMail({
						'###TYP###': this.hd.label,
						'###MASS1###': this.ff2(mass1),
						'###MASS2###': this.ff2(mass2),
						'###QUERSCHNITT###': this.ff2(this.state.dim.hd.area_m2),
						'###DURCHMESSER_HD###': this.ff2(this.state.dim.hd.hyd_mm),
						'###DURCHMESSER_EMPF###': this.ff2(this.state.dim.hd.hyd_propose_mm),
					}, mail_key);
					
				}
								
			},
			calcRE() {
				
				if (
					(!this.state.dim.rundeckig.re.input.normalwidth_mm || this.state.dim.rundeckig.re.input.normalwidth_mm <= 0) ||
					(
						(!this.state.dim.rundeckig.re.input.height_mm || this.state.dim.rundeckig.re.input.height_mm <= 0) &&
						(!this.state.dim.rundeckig.re.input.width_mm || this.state.dim.rundeckig.re.input.width_mm <= 0)
					)
				) {
					
					this.alert('Bitte gültige Werte eingeben für Nennweite und Breite oder Höhe.');
					return;
					
				}
				
				this.state.dim.rundeckig.re.output.area_m2 = Math.PI * this.state.dim.rundeckig.re.input.normalwidth_mm * this.state.dim.rundeckig.re.input.normalwidth_mm / 4;
				
				this.state.dim.rundeckig.re.output.height_mm = this.state.dim.rundeckig.re.input.height_mm;
				this.state.dim.rundeckig.re.output.width_mm = this.state.dim.rundeckig.re.input.width_mm;
 
				if (!this.state.dim.rundeckig.re.input.height_mm || this.state.dim.rundeckig.re.input.height_mm === 0) {
					
					this.state.dim.rundeckig.re.output.height_mm = this.state.dim.rundeckig.re.output.area_m2 / this.state.dim.rundeckig.re.input.width_mm;
					
				}
				
				if (!this.state.dim.rundeckig.re.input.width_mm || this.state.dim.rundeckig.re.input.width_mm === 0) {
				
					this.state.dim.rundeckig.re.output.width_mm = this.state.dim.rundeckig.re.output.area_m2 / this.state.dim.rundeckig.re.input.height_mm;
					 
				}
				
				this.state.dim.rundeckig.re.output.area_m2 = this.state.dim.rundeckig.re.output.area_m2 / 1000000;
				
			},
			calcER() {
				
				if (
					(!this.state.dim.rundeckig.er.input.height_mm || this.state.dim.rundeckig.er.input.height_mm === 0) ||
					(!this.state.dim.rundeckig.er.input.width_mm || this.state.dim.rundeckig.er.input.width_mm === 0)
				) {
					
					this.alert('Bitte gültige Werte eingeben für Breite und Höhe.');
					return;
					
				}
				
				this.state.dim.rundeckig.er.output.area_m2 = (this.state.dim.rundeckig.er.input.height_mm / 1000) * (this.state.dim.rundeckig.er.input.width_mm / 1000); 
				this.state.dim.rundeckig.er.output.normalwidth_mm = Math.sqrt((this.state.dim.rundeckig.er.output.area_m2 * 1000000) * 4 / Math.PI);
				this.state.dim.rundeckig.er.output.diameter_mm = this.calc_hd_empf(this.state.dim.rundeckig.er.output.normalwidth_mm);
				 
			}
		},
		computed: {
			hd() {
				
				for (let i in this.arHd) {
					
					if (i === this.state.dim.hd.type) return this.arHd[i];
					
				}
				
			}	
		},
		props: {
			state: Object
		},
		data() {
			return {
				arHd: {
					'rund': { img: 'img/dim/hd/hdrund.png', label: 'Rund', formula: 'dh = d' },
					'quadratisch': { img: 'img/dim/hd/hdquadratisch.png', label: 'Quadratisch', formula: 'dh = a' },
					'rechteckig': { img: 'img/dim/hd/hdrechteckig.png', label: 'Rechteckig', formula: 'dh = (2 * a * b)/(a + b)' },
					'ellipse': { img: 'img/dim/hd/hdellipse.png', label: 'Ellipse', formula: 'dh = 4 * A / U' },
					'oval': { img: 'img/dim/hd/hdoval.png', label: 'Oval', formula: 'dh = 4 * A / U' },
					'dreieck': { img: 'img/dim/hd/hddreieck.png', label: 'Dreieck', formula: 'dh = (a² * √3)/(3 * a)' },
					'beliebig': { img: 'img/dim/hd/hdbeliebig.png', label: 'Beliebig', formula: 'dh = 4 * A / U' },
					'kreisring': { img: 'img/dim/hd/hdkreisring.png', label: 'Kreisring', formula: 'dh = D - d' }
				}
			}
		},
	}

</script>

<style lang="scss">



</style>